// import React from "react";
// import InstitutionLayout from "../components/InstitutionLayout";


// const Tarifictions = () => {
//   return (
//     <InstitutionLayout title="Fiche de paie - Sanacare">
    
//     <div style={{ maxWidth: 800, margin: "auto", padding: 20, fontFamily: "Arial, sans-serif" }}>
//       <h1>Détails des Calculs des Tarifications</h1>
//       <p>
//         Cette page explique la structure des tarifs appliqués selon le personnel et le moment de l'intervention.
//       </p>

//       <h2>Tarification pour un Infirmier</h2>
//       <ul>
//         <li>Jour en semaine : 50 €</li>
//         <li>Frais de déplacement en semaine : 10 €</li>
//         <li>Week-end : 60 €</li>
//         <li>Frais de déplacement en week-end : 10 €</li>
//         <li>Nuit en semaine : 65 €</li>
//         <li>Frais de déplacement de nuit en semaine : 15 €</li>
//         <li>Nuit en week-end : 70 €</li>
//         <li>Frais de déplacement de nuit en week-end : 15 €</li>
//       </ul>

//       <h2>Tarification pour un Aide-Soignant</h2>
//       <ul>
//         <li>Jour en semaine : 38 €</li>
//         <li>Frais de déplacement en semaine : 10 €</li>
//         <li>Week-end : 48 €</li>
//         <li>Frais de déplacement en week-end : 10 €</li>
//         <li>Nuit en semaine : 52 €</li>
//         <li>Frais de déplacement de nuit en semaine : 15 €</li>
//         <li>Nuit en week-end : 55 €</li>
//         <li>Frais de déplacement de nuit en week-end : 15 €</li>
//       </ul>

//       <h2>Mode de Calcul</h2>
//       <p>
//         Le tarif total est la somme du tarif applicable à la période (jour/semaine, week-end, nuit) et des frais de déplacement correspondants.
//       </p>

//       <h3>Exemples</h3>
//       <ul>
//         <li>Intervention infirmier jour semaine sans déplacement = 50 €</li>
//         <li>Intervention infirmier jour semaine avec déplacement = 50 € + 10 € = 60 €</li>
//         <li>Intervention aide-soignant nuit week-end avec déplacement = 55 € + 15 € = 70 €</li>
//       </ul>
//     </div>
//     </InstitutionLayout>
//   );
// };

// export default Tarifictions;






import React, { useState, useEffect } from "react";
import { useAuth } from '../App';
import InstitutionLayout from "../components/InstitutionLayout";

const Tarifictions = () => {
  const { axiosInstance } = useAuth();
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstitution = async () => {
      try {
        const response = await axiosInstance.get('/institutions/profile');
        setInstitution(response.data);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement des tarifs");
      } finally {
        setLoading(false);
      }
    };

    fetchInstitution();
  }, [axiosInstance]);

  if (loading) return <div className="flex justify-center items-center h-64">Chargement des tarifs...</div>;
  if (error) return <div className="text-red-600 text-center p-8">{error}</div>;
  if (!institution?.tarification) return <div className="text-gray-500 text-center p-8">Aucune tarification disponible</div>;

  const { name, tarification = {} } = institution;
  const { infirmier = {}, aide_soignant = {} } = tarification;

  return (
    <InstitutionLayout title="Tarifications">
      <div style={{ maxWidth: 900, margin: "0 auto", padding: 24, fontFamily: "Arial, sans-serif" }}>
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Tarifications</h1>
          <h1>Détails des Calculs des Tarifications</h1>
      <p>
        Cette page explique la structure des tarifs appliqués selon le personnel et le moment de l'intervention.
      </p>
      <br>
      </br>
          <h2 className="text-xl text-gray-600">{name}</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Infirmier */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-2xl font-semibold text-amber-800 mb-6 flex items-center">
              👨‍⚕️ Infirmier
            </h2>
            <div className="space-y-3 text-lg">
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Jour semaine</span>
                <span className="font-bold">{infirmier.weekday_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>+ Déplacement semaine</span>
                <span className="font-bold text-amber-600">+{infirmier.travel_weekday_fee || 'N/A'} €</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Week-end</span>
                <span className="font-bold">{infirmier.weekend_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>+ Déplacement week-end</span>
                <span className="font-bold text-amber-600">+{infirmier.travel_weekend_fee || 'N/A'} €</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Nuit semaine</span>
                <span className="font-bold">{infirmier.night_week_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2">
                <span>+ Déplacement nuit semaine</span>
                <span className="font-bold text-amber-600">+{infirmier.travel_night_week_fee || 'N/A'} €</span>
              </div>
            </div>
          </div>

          {/* Aide-Soignant */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-2xl font-semibold text-blue-800 mb-6 flex items-center">
              👨‍🏥 Aide-Soignant
            </h2>
            <div className="space-y-3 text-lg">
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Jour semaine</span>
                <span className="font-bold">{aide_soignant.weekday_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>+ Déplacement semaine</span>
                <span className="font-bold text-blue-600">+{aide_soignant.travel_weekday_fee || 'N/A'} €</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Week-end</span>
                <span className="font-bold">{aide_soignant.weekend_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>+ Déplacement week-end</span>
                <span className="font-bold text-blue-600">+{aide_soignant.travel_weekend_fee || 'N/A'} €</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span>Nuit semaine</span>
                <span className="font-bold">{aide_soignant.night_week_rate || 'N/A'} €/h</span>
              </div>
              <div className="flex justify-between py-2">
                <span>+ Déplacement nuit semaine</span>
                <span className="font-bold text-blue-600">+{aide_soignant.travel_night_week_fee || 'N/A'} €</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mode de calcul */}
        <div className="bg-gradient-to-r from-amber-50 to-blue-50 rounded-2xl p-8 border border-amber-200">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">📊 Mode de calcul</h2>
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-amber-600 mb-2">50€</div>
              <div className="text-sm text-gray-600">Tarif/heure</div>
              <div className="text-xs text-gray-500">× 4h = 200€</div>
            </div>
            <div className="border-l border-r border-gray-200 h-20 my-4 md:my-0 flex items-center">
              <span className="text-lg font-bold text-gray-600">+</span>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">10€</div>
              <div className="text-sm text-gray-600">Déplacement</div>
            </div>
            <div className="col-span-3 mt-6 pt-6 border-t border-gray-200">
              <div className="text-xl font-semibold text-gray-900">
                <span className="text-2xl text-amber-700">=</span> 210€
              </div>
              <p className="text-sm text-gray-600 mt-1 font-medium">
                Tarif total = (tarif × nombre d'heures) + déplacement
              </p>
            </div>
          </div>
        </div>
      </div>
    </InstitutionLayout>
  );
};

export default Tarifictions;
